import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-weidakaiwenjianjia-copy",
  "use": "icon-weidakaiwenjianjia-copy-usage",
  "viewBox": "0 0 1280 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1280 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-weidakaiwenjianjia-copy\"><path d=\"M1152 128H576l-128-128H128C57.6 0 0 57.6 0 128v256h1280V256c0-70.4-57.6-128-128-128z\" fill=\"#FFCA28\" /><path d=\"M1152 128H128C57.6 128 0 185.6 0 256v640c0 70.4 57.6 128 128 128h1024c70.4 0 128-57.6 128-128V256c0-70.4-57.6-128-128-128z\" fill=\"#FFCA28\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol